// Lightweight client-side event tracking.
// Pushes to GTM dataLayer and GA4 (gtag) if present. Safe no-op otherwise.

export function trackEvent(event, params = {}) {
  try {
    if (typeof window === "undefined") return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
    if (typeof window.gtag === "function") {
      window.gtag("event", event, params);
    }
  } catch {
    // never let tracking break UX
  }
}

// Convenience: track a WhatsApp click from a named source
export function trackWhatsAppClick(source) {
  trackEvent("whatsapp_click", { wa_source: source, contact_method: "whatsapp" });
}

// Convenience: track a phone/call click from a named source
export function trackCallClick(source) {
  trackEvent("call_click", { call_source: source, contact_method: "phone" });
}
